import { api } from "./api";
import { AxiosError } from "axios";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const fetchProductListingData = async (endpoint: string) => {
  try {
    const response = await api.get(endpoint, {
      params: {
        page: 1,
        pageSize: 100,
      },
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(
        "Error fetching products:",
        error.response?.data || error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw new Error("Failed to fetch products");
  }
};
